import { jsx as _jsx } from "react/jsx-runtime";
import { Tooltip, useMapContext } from "@evergis/react";
export const MapTooltip = ({ content, zIndex }) => {
    const { map } = useMapContext();
    return (_jsx(Tooltip, { map: map, content: content, zIndex: zIndex }));
};
